// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__F2npv","head":"Table_head__27hOs","col":"Table_col__3qM0O"};